(() => {
  const DEFAULT_FORM_ID = 'S8Qwud';
  const ROOT_SELECTOR = '[role="dialog"][aria-label="POPUP Form"]';
  const MODAL_CLASS = 'bravo-klaviyo-modal';
  const PROCESSED_ATTR = 'data-bravo-klaviyo-processed';
  const DESKTOP_IMAGE_ASSET = '/cdn/shop/t/8/assets/klaviyo-newsletter-desktop.png';

  const getTargetFormId = () => {
    const customFormId = window.BravoKlaviyoModal?.formId;
    if (typeof customFormId === 'string' && customFormId.trim() !== '') {
      return customFormId.trim();
    }

    return DEFAULT_FORM_ID;
  };

  const getFormSelectors = (formId) => [
    `[data-testid="klaviyo-form-${formId}"]`,
    `.klaviyo-form-${formId}`,
  ];

  const getDesktopImage = () => {
    const customImage = window.BravoKlaviyoModal?.desktopImage;
    if (typeof customImage === 'string' && customImage.trim() !== '') {
      return customImage.trim();
    }

    const preloadImage = document.querySelector('link[href*="klaviyo-newsletter-desktop.png"]');
    const preloadHref = preloadImage?.getAttribute('href');
    if (typeof preloadHref === 'string' && preloadHref.trim() !== '') {
      return preloadHref.trim();
    }

    return DESKTOP_IMAGE_ASSET;
  };

  const findForm = (root, formId) => {
    const formSelectors = getFormSelectors(formId);
    for (const selector of formSelectors) {
      const match = root.querySelector(selector);
      if (match instanceof HTMLElement) {
        return match;
      }
    }
    return null;
  };

  const labelButtonKind = (button) => {
    const isCountryPickerTrigger =
      button.getAttribute('role') === 'combobox'
      || button.getAttribute('aria-haspopup') === 'listbox'
      || (button.getAttribute('aria-label') || '').toLowerCase().includes('search countries');

    if (isCountryPickerTrigger) {
      button.removeAttribute('data-bravo-klaviyo-button');
      return;
    }

    const text = button.textContent?.trim().toLowerCase() || '';
    button.setAttribute('data-aim', '');
    if (text.includes('no thanks')) {
      button.setAttribute('data-bravo-klaviyo-button', 'secondary');
    } else {
      button.setAttribute('data-bravo-klaviyo-button', 'primary');
    }
  };

  const applyModalClasses = (root) => {
    if (!(root instanceof HTMLElement)) {
      return;
    }

    const targetFormId = getTargetFormId();
    const form = findForm(root, targetFormId);
    if (!(form instanceof HTMLElement)) {
      root.setAttribute(PROCESSED_ATTR, 'skipped');
      return;
    }

    root.classList.add(MODAL_CLASS);

    const shell = root.firstElementChild;
    if (shell instanceof HTMLElement) {
      shell.classList.add('bravo-klaviyo-modal__shell');
      shell.style.setProperty('--bravo-klaviyo-modal-image', `url("${getDesktopImage()}")`);

      let leftPanel = shell.querySelector('.bravo-klaviyo-modal__left-panel');
      if (!(leftPanel instanceof HTMLElement)) {
        leftPanel = document.createElement('div');
        leftPanel.className = 'bravo-klaviyo-modal__left-panel';
        shell.insertBefore(leftPanel, shell.firstChild);
      }
    }

    const popup = root.querySelector('[data-testid="POPUP"]');
    if (popup instanceof HTMLElement) {
      popup.classList.add('bravo-klaviyo-modal__popup');
    }

    form.classList.add('bravo-klaviyo-modal__form');

    const heading = form.querySelector('[id^="rich-text-"]');
    if (heading instanceof HTMLElement) {
      heading.classList.add('bravo-klaviyo-modal__heading');
    }

    const richBlocks = form.querySelectorAll('[id^="rich-text-"]');
    if (richBlocks.length > 1 && richBlocks[1] instanceof HTMLElement) {
      richBlocks[1].classList.add('bravo-klaviyo-modal__subheading');
    }

    const label = form.querySelector('label[for*="phone_number"], label');
    if (label instanceof HTMLElement && label.textContent?.trim()) {
      label.textContent = 'EMAIL';
    }

    form.querySelectorAll('button[type="button"]').forEach((button) => {
      if (button instanceof HTMLButtonElement) {
        labelButtonKind(button);
      }
    });

    const closeButton = root.querySelector('.klaviyo-close-form');
    if (closeButton instanceof HTMLElement) {
      closeButton.classList.add('bravo-klaviyo-modal__close');
      closeButton.setAttribute('data-aim', '');
    }

    root.setAttribute(PROCESSED_ATTR, 'done');
  };

  const processExisting = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((modal) => {
      if (!(modal instanceof HTMLElement)) {
        return;
      }
      applyModalClasses(modal);
    });
  };

  processExisting();

  const queue = new Set();
  let rafId = null;

  const flushQueue = () => {
    queue.forEach((modal) => applyModalClasses(modal));
    queue.clear();
    rafId = null;
  };

  const scheduleFlush = () => {
    if (rafId !== null) {
      return;
    }
    rafId = window.requestAnimationFrame(flushQueue);
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) {
          continue;
        }

        if (node.matches(ROOT_SELECTOR)) {
          queue.add(node);
          continue;
        }

        const nestedModal = node.querySelector(ROOT_SELECTOR);
        if (nestedModal instanceof HTMLElement) {
          queue.add(nestedModal);
        }

        const parentModal = node.closest(ROOT_SELECTOR);
        if (parentModal instanceof HTMLElement) {
          queue.add(parentModal);
        }
      }
    }

    if (queue.size > 0) {
      scheduleFlush();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

})();
